import {
    Box,
    Divider,
    Grid,
    Paper,
    TextField,
    Typography,
  } from "@mui/material";
  import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
  import { Doughnut } from "react-chartjs-2";
  import SearchIcon from "@mui/icons-material/Search";
  
  ChartJS.register(ArcElement, Tooltip, Legend);
  
  function EmployerChart() {
    const data1 = {
      labels: ["Got Placed", "Trained Candidates",],
      datasets: [
        {
          label: "%",
          data: [48.8, 24.3, 26.9],
          borderColor: ["rgba(255,206,86,0.2)"],
          backgroundColor: ["#2544EE", "#ECE9FF", "#ACD4F7"],
          pointBackgroundColor: "rgba(255,206,86,0.2)",
        },
      ],
    };
    const data2 = {
      labels: ["Haryana","Delhi", "Rajasthan"],
      datasets: [
        {
          label: "%",
          data: [48.8, 24.3, 26.9],
          borderColor: ["rgba(255,206,86,0.2)"],
          backgroundColor: ["#2544EE", "#ECE9FF", "#ACD4F7"],
          pointBackgroundColor: "rgba(255,206,86,0.2)",
        },
      ],
    };
    const data3 = {
      labels: ["Fresher", "Experience", "Employers",],
      datasets: [
        {
          label: "%",
          data: [16.8, 32.8, 24.3, 26.9],
          borderColor: ["rgba(255,206,86,0.2)"],
          backgroundColor: ["#2544EE", "#ECE9FF", "#ACD4F7","#8BACF8"],
          pointBackgroundColor: "rgba(255,206,86,0.2)",
        },
      ],
    };
  
  
    return (
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent:'space-between',
            mt: 8,
            borderRadius: "10px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: { md: "30px", xs: "20px" },
              lineHeight: "36px",
              color: "#000000",
            }}
          >
            Welcome to <span style={{color:'#2544EE'}}>PPLACD</span>
          </Typography>
          <Grid
            item
            md={4}
            sx={{
              display: "flex",
              verticalAlign: "middle",
              alignItems: "center",
            }}
          >
            <TextField
              sx={{ marginLeft: "1rem" }}
              className="profile-skills-box text2Light"
              variant="outlined"
              size="small"
              placeholder="Search"
              InputProps={{
                endAdornment: <SearchIcon sx={{ opacity: "0.5" }} />,
              }}
            />
          </Grid>
        </Box>
  
  
      
  
        <Box sx={{ pt: 5 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Paper>
                <Box
                  sx={{
                    textAlign: "start",
                    p: 2,
                    fontSize: "22px",
                    fontWeight: 600,
                    fontFamily: "Inter",
                  }}
                >
                  <Box>
                    <Typography pb={1} className="subHeading2Bold">How Many Schedule Interview</Typography>
                    <Divider />
                  </Box>
                  <Box p={3}>
                  <Doughnut data={data1}  />
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper>
                <Box
                  sx={{
                    textAlign: "start",
                    p: 2,
                    fontSize: "22px",
                    fontWeight: 600,
                    fontFamily: "Inter",
                  }}
                >
                  <Box>
                    <Typography pb={1} className="subHeading2Bold">Candidates</Typography>
                    <Divider />
                  </Box>
                  <Box p={3}>
                  <Doughnut data={data2}  />
                  </Box>
                
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper>
                <Box
                  sx={{
                    textAlign: "start",
                    p: 2,
                    fontSize: "22px",
                    fontWeight: 600,
                    fontFamily: "Inter",
                  }}
                >
                  <Box>
                    <Typography pb={1} className="subHeading2Bold">Candidates Experience</Typography>
                    <Divider />
                  </Box>
                  <Box p={3}>
                  <Doughnut data={data3}  />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Box>
  
  
  
      </Box>
    );
  }
  
  export default EmployerChart;
  